module.exports = __webpack_public_path__ + "img/general_practice.63005431.svg";